import { useState } from "react";
import { Box, Typography, Card, Collapse, IconButton, useMediaQuery } from "@mui/material";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import COLORS from "../../../../../constants/colors";

const faqs = [
  {
    question: "Who can use the Yamba Africa platform?",
    answer: `To use the platform, you must be at least 18 years old and legally capable of entering into contracts.`,
  },
  {
    question: "How do I start a fundraising campaign?",
    answer: `Click on "Add Campaign", provide details such as title, goal amount, and description. Upload images or videos, then share your link.`,
  },
  {
    question: "Is there a limit to how many campaigns I can create?",
    answer: `Yes. You can have a maximum of one active campaigns at a time.`,
  },
  {
    question: "Are there any fees for donations and withdrawals?",
    answer: `Yes. A 4.25% transaction fee is applied per donation. Withdrawal fees range from 3,000 UGX to 10,000 UGX based on amount.`,
  },
  {
    question: "What is the minimum amount I can withdraw?",
    answer: `The minimum withdrawal amount is 20,000 UGX.`,
  },
  {
    question: "How long does it take to receive my withdrawal?",
    answer: `Withdrawals are processed between 8AM - 5PM and typically reach your account within 1 to 4 hours.`,
  },
  {
    question: "What activities are prohibited on the platform?",
    answer: `You may not post misleading campaigns, use the platform unlawfully, or bypass campaign limits. Violations can lead to suspension.`,
  },
  {
    question: "Is my account and information secure?",
    answer: `Yes. Data is encrypted, payment processing is secure, and we recommend enabling 2FA for added protection.`,
  },
  {
    question: "How do I contact support?",
    answer: `You can use the Help Center in your dashboard or email support@yambaafrica.com. Tickets are answered within 24 hours.`,
  },
];

const FaqCard = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Card
      sx={{
        p: isSmallScreen ? 2 : 4,
        mt: 6,
        borderRadius: 2,
        boxShadow: 0,
        bgcolor: "#fff",
        textAlign: "left",
        mx: "auto",
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        sx={{
          mb: 3,
          color: COLORS.primary,
          textAlign: "left",
          fontSize: isSmallScreen ? "1.2rem" : "1.5rem",
        }}
      >
        Frequently Asked Questions
      </Typography>

      {faqs.map((faq, index) => (
        <Box key={index} sx={{ mb: 2, pb: 1 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
              py: 1.5,
              borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            }}
            onClick={() => toggleFaq(index)}
          >
            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{
                color: "#333",
                fontSize: isSmallScreen ? "0.8rem" : "1rem",
              }}
            >
              {faq.question}
            </Typography>
            <IconButton size="small" sx={{ color: COLORS.primary }}>
              {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </IconButton>
          </Box>

          <Collapse in={openIndex === index}>
            <Typography
              variant="body2"
              sx={{
                mt: 1,
                color: "#666",
                pl: 2,
                whiteSpace: "pre-line",
                fontSize: isSmallScreen ? "0.7rem" : "0.8rem",
              }}
            >
              {faq.answer}
            </Typography>
          </Collapse>
        </Box>
      ))}
    </Card>
  );
};

export default FaqCard;
